/* amb-cart — Amberton custom cart drawer.
   Registers as <cart-drawer> so Dawn's product-form finds it and calls open()/renderContents().
   Renders entirely from /cart.js so what we draw is what checkout charges.
   All interaction is DELEGATED from the root, so nothing needs re-binding after a re-render. */
(function () {
  if (customElements.get('cart-drawer')) return;

  var CFG = window.AMB_CART_CONFIG || {};
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return (CFG.currencySymbol || '$') + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var img = function (src, w) {
    if (!src) return '';
    return src.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$1$3');
  };

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_BIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';
  var ICON_BOX = '<svg viewBox="0 0 48 48" fill="none"><path d="M24 4 6 13v22l18 9 18-9V13L24 4Z" fill="#d9dcf5"/><path d="M24 4 6 13l18 9 18-9L24 4Z" fill="#eceef9"/><circle cx="34" cy="33" r="9" fill="#1e2fd5"/><path d="m30 33 3 3 6-6" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  class AmbCart extends HTMLElement {
    connectedCallback() {
      this.state = null;
      this.busy = false;
      this.body = this.querySelector('[data-amb-body]');
      this.foot = this.querySelector('[data-amb-foot]');
      this.countEl = this.querySelector('[data-amb-count]');

      // A transformed ancestor scopes position:fixed and z-index. Re-parent to <body>
      // so the drawer is always measured against the viewport, never a parent's box.
      if (this.parentElement !== document.body) document.body.appendChild(this);

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') this.close(); }.bind(this));

      var icon = document.querySelector('#cart-icon-bubble');
      if (icon) {
        icon.setAttribute('role', 'button');
        icon.addEventListener('click', function (e) { e.preventDefault(); this.open(); }.bind(this));
      }
      this.refresh();
    }

    /* ---------- open / close ---------- */
    open() { this.classList.add('is-open'); document.body.style.overflow = 'hidden'; if (!this.state) this.refresh(); }
    close() { this.classList.remove('is-open'); document.body.style.overflow = ''; }

    /* ---------- Dawn compatibility surface ----------
       Dawn's product-form.js treats whatever it finds at <cart-drawer> as its cart and
       calls getSectionsToRender() BEFORE posting the add. If that method is missing it
       throws, the add never fires and the drawer never opens. It then calls
       renderContents() with the response. We re-render from /cart.js ourselves, so we
       ask for no sections — but the methods must exist. */
    getSectionsToRender() { return []; }

    getSectionInnerHTML() { return ''; }

    setActiveElement(el) { this.activeElement = el; }

    async renderContents(parsedState) {
      if (parsedState && parsedState.sections) { /* unused — we read /cart.js */ }
      this.classList.remove('is-empty');
      await this.refresh();
      this.syncBubble();
      this.open();
    }

    /* ---------- data ---------- */
    async refresh() {
      try {
        var cart = await fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        this.state = cart;
        this.render();
      } catch (e) { console.warn('[amb-cart] refresh failed', e); }
    }

    setBusy(on) { this.busy = on; this.classList.toggle('is-busy', !!on); }

    async mutate(body) {
      if (this.busy) return;
      this.setBusy(true);
      try {
        var cart = await fetch(CFG.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(r => r.json());
        this.state = cart;
        this.render();
        this.syncBubble();
      } catch (e) { console.warn('[amb-cart] change failed', e); await this.refresh(); }
      this.setBusy(false);
    }

    async add(variantId, qty, properties) {
      if (this.busy) return;
      this.setBusy(true);
      try {
        await fetch(CFG.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [Object.assign({ id: variantId, quantity: qty || 1 }, properties ? { properties: properties } : {})] })
        });
        await this.refresh();
        this.syncBubble();
      } catch (e) { console.warn('[amb-cart] add failed', e); }
      this.setBusy(false);
    }

    syncBubble() {
      var b = document.querySelector('#cart-icon-bubble .cart-count-bubble span, #cart-icon-bubble .cart-count-bubble');
      if (b && this.state) b.textContent = this.state.item_count;
    }

    /* ---------- events (delegated — survives every re-render) ---------- */
    onClick(e) {
      var t = e.target.closest('[data-amb]');
      if (!t) return;
      var act = t.getAttribute('data-amb');

      if (act === 'close') { e.preventDefault(); return this.close(); }
      if (act === 'overlay') { e.preventDefault(); return this.close(); }

      if (act === 'inc' || act === 'dec') {
        e.preventDefault();
        var line = parseInt(t.getAttribute('data-line'), 10);
        var q = parseInt(t.getAttribute('data-qty'), 10) + (act === 'inc' ? 1 : -1);
        return this.mutate({ line: line, quantity: Math.max(0, q) });
      }
      if (act === 'remove') {
        e.preventDefault();
        return this.mutate({ line: parseInt(t.getAttribute('data-line'), 10), quantity: 0 });
      }
      if (act === 'add-upsell') {
        e.preventDefault();
        t.disabled = true;
        var vid = parseInt(t.getAttribute('data-variant'), 10), self = this;
        if (!t.hasAttribute('data-deal')) return this.add(vid, 1);
        return this.dealProps().then(function (props) { return self.add(vid, 1, props); });
      }
      if (act === 'protect') {
        e.preventDefault();
        var on = t.getAttribute('aria-checked') === 'true';
        if (on) {
          var ln = this.lineOf(CFG.protection.variantId);
          if (ln) return this.mutate({ line: ln, quantity: 0 });
        } else {
          return this.add(CFG.protection.variantId, 1);
        }
      }
      if (act === 'nav') {
        e.preventDefault();
        var track = this.querySelector('[data-amb-track]');
        if (track) track.scrollBy({ left: (t.getAttribute('data-dir') === 'next' ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
      }
      if (act === 'checkout') { e.preventDefault(); window.location.href = '/checkout'; }
    }

    /* Kaching prices its checkbox upsell (id xBL6 = Questions & Us at $9.99) only when the
       add-on line carries the same bundle id + deal version as the main book line. With the
       page checkbox switched off, Kaching no longer stamps an id on the book line, so we
       stamp one (cart/change keeps quantity, merges the existing Kaching properties), then
       tag the deck with it. No Kaching-tagged book line → add plain; the automatic discount
       'Cart Upsell — Questions & Us $9.99 with Games & Us' covers the 1-book case. */
    async dealProps() {
      /* 2026-10-31 (Tony): cart deck price is $12.99, set by the automatic discount
         'Questions & Us — flat $9 off ($12.99)'. Kaching's xBL6 still prices the PDP checkbox
         at $9.99, so the cart adds the deck plain instead of tagging it into the Kaching deal. */
      return null;
      var D = CFG.dealUpsell, items = (this.state && this.state.items) || [];
      for (var i = 0; i < items.length; i++) {
        var raw = items[i].product_id === D.requiresProductId && items[i].properties && items[i].properties.__kaching_bundles;
        if (!raw) continue;
        try {
          var k = JSON.parse(raw);
          if (!k.v) continue;
          if (!k.id) {
            k.id = 'amb' + Math.random().toString(36).slice(2, 6);
            var props = Object.assign({}, items[i].properties, { __kaching_bundles: JSON.stringify(k) });
            await fetch(CFG.routes.cartChange + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: i + 1, quantity: items[i].quantity, properties: props })
            });
          }
          return { __kaching_bundles: JSON.stringify({ id: k.id, deal: k.deal, v: k.v, checkboxUpsell: D.upsellId }) };
        } catch (e) { console.warn('[amb-cart] deal tag failed', e); }
      }
      return null;
    }

    lineOf(variantId) {
      if (!this.state) return 0;
      for (var i = 0; i < this.state.items.length; i++) if (this.state.items[i].variant_id === variantId) return i + 1;
      return 0;
    }

    /* ---------- render ---------- */
    render() {
      var c = this.state;
      if (!c) return;
      if (this.countEl) this.countEl.textContent = c.item_count;

      if (!c.item_count) {
        this.body.innerHTML = '<div class="amb-cart__empty"><p>Your cart is empty.</p><a href="/collections/all">Keep shopping</a></div>';
        this.foot.innerHTML = '';
        return;
      }

      var protLine = this.lineOf(CFG.protection.variantId);
      var html = '';

      c.items.forEach(function (it, i) {
        if (it.variant_id === CFG.protection.variantId) return;   // protection lives in the footer
        var saved = it.original_line_price - it.final_line_price;
        var tags = (it.line_level_discount_allocations || [])
          .map(function (d) { return d.discount_application && d.discount_application.title; })
          .filter(Boolean)
          .filter(function (title) {
            // Kaching names EVERY allocation after the deal tier, so a 1-qty add-on inherits
            // "2 Books". Only show the tier badge where the line's own quantity earns it.
            var n = parseInt((title.match(/\d+/) || [])[0], 10);
            return !n || it.quantity >= n;
          });

        html +=
          '<div class="amb-line' + (saved > 0 ? ' amb-line--disc' : '') + '">' +
            '<a href="' + esc(it.url) + '"><img class="amb-line__img" src="' + esc(img(it.image, 180)) + '" alt="" loading="lazy"></a>' +
            '<div>' +
              '<p class="amb-line__title">' + esc(it.product_title) + '</p>' +
              (it.variant_title && it.variant_title !== 'Default Title'
                ? '<p class="amb-line__variant">' + esc(it.variant_title) + '</p>' : '') +
              '<div class="amb-line__prices">' +
                (saved > 0 ? '<span class="amb-line__was">' + money(it.original_line_price) + '</span>' : '') +
                '<span class="amb-line__now">' + money(it.final_line_price) + '</span>' +
                (saved > 0 ? '<span class="amb-line__save">(Save ' + money(saved) + ')</span>' : '') +
              '</div>' +
              '<div class="amb-qty">' +
                '<button type="button" data-amb="dec" data-line="' + (i + 1) + '" data-qty="' + it.quantity + '" aria-label="Decrease">&minus;</button>' +
                '<span class="amb-qty__n">' + it.quantity + '</span>' +
                '<button type="button" data-amb="inc" data-line="' + (i + 1) + '" data-qty="' + it.quantity + '" aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="amb-line__right">' +
              '<button type="button" class="amb-line__remove" data-amb="remove" data-line="' + (i + 1) + '" aria-label="Remove">' + ICON_BIN + '</button>' +
              (tags.length ? '<span class="amb-tag">' + esc(tags[0]) + '</span>' : '') +
            '</div>' +
          '</div>';
      });

      /* upsells — hide anything already in the cart */
      var inCart = {};
      c.items.forEach(function (it) { inCart[it.product_id] = true; });
      var ups = (CFG.upsells || []).filter(function (u) { return !inCart[u.productId]; });
      var D = CFG.dealUpsell;
      if (D && D.variantId && (inCart[D.requiresProductId] || (D.bookIds || []).some(function (id) { return inCart[id]; })) && !inCart[D.productId]) ups.unshift(D);
      if (ups.length) {
        html += '<div class="amb-ups' + (ups.length > 1 ? ' amb-ups--multi' : '') + '">' +
          '<h3 class="amb-ups__h">' + esc(CFG.upsellHeading || "You'll Want These By Your Side.") + '</h3>' +
          '<div class="amb-ups__wrap">' +
            '<button type="button" class="amb-ups__nav amb-ups__nav--prev" data-amb="nav" data-dir="prev" aria-label="Previous">&#8249;</button>' +
            '<div class="amb-ups__track" data-amb-track>' +
              ups.map(function (u) {
                return '<div class="amb-ups__card">' +
                  '<img class="amb-ups__img" src="' + esc(img(u.image, 200)) + '" alt="" loading="lazy">' +
                  '<div>' +
                    '<p class="amb-ups__t">' + esc(u.title) + '</p>' +
                    (u.subtitle ? '<p class="amb-ups__sub">' + esc(u.subtitle) + '</p>' : '') +
                    '<div class="amb-ups__p">' +
                      (u.compareAt > u.price ? '<span class="amb-ups__was">' + money(u.compareAt) + '</span>' : '') +
                      '<span class="amb-ups__now">' + money(u.price) + '</span>' +
                    '</div>' +
                    '<button type="button" class="amb-ups__add" data-amb="add-upsell" data-variant="' + u.variantId + '"' + (u.deal ? ' data-deal' : '') + '>Add</button>' +
                  '</div>' +
                '</div>';
              }).join('') +
            '</div>' +
            '<button type="button" class="amb-ups__nav amb-ups__nav--next" data-amb="nav" data-dir="next" aria-label="Next">&#8250;</button>' +
          '</div></div>';
      }

      this.body.innerHTML = html;

      /* ---------- footer ---------- */
      var f = '';
      /* trust chips — factual, mirrored from the PDP. In the footer so they are never
         clipped by the scroll area. */
      if (CFG.trust && CFG.trust.length) {
        f += '<div class="amb-trust">' + CFG.trust.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('') + '</div>';
      }
      if (CFG.protection && CFG.protection.variantId) {
        f += '<div class="amb-prot">' +
          '<span class="amb-prot__ico">' + (CFG.protection.image ? '<img src="' + esc(img(CFG.protection.image, 120)) + '" alt="">' : ICON_BOX) + '</span>' +
          '<div><p class="amb-prot__t">' + esc(CFG.protection.title) + '</p><p class="amb-prot__d">' + esc(CFG.protection.text) + '</p></div>' +
          '<span class="amb-prot__p">' + money(CFG.protection.price) + '</span>' +
          '<button type="button" class="amb-sw" data-amb="protect" role="switch" aria-checked="' + (protLine ? 'true' : 'false') + '" aria-label="' + esc(CFG.protection.title) + '"></button>' +
        '</div>';
      }

      /* ONE savings row, always — never a stack of them. Collect every discount Shopify
         reports (cart-level AND Kaching's line-level allocations), show the tier pills
         inline, and print the single authoritative number: cart.total_discount.
         Using total_discount means this row can never disagree with checkout. */
      var pills = [];
      (c.cart_level_discount_applications || []).forEach(function (d) {
        if (d.title) pills.push(d.title);
      });
      var seen = {};
      c.items.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (d) {
          var t = d.discount_application && d.discount_application.title;
          if (t && !seen[t]) { seen[t] = 1; pills.push(t); }
        });
      });
      if (c.total_discount > 0) {
        f += '<div class="amb-disc">' +
               '<span class="amb-disc__label">You save</span>' +
               '<span class="amb-disc__pills">' +
                 pills.map(function (p) { return '<span class="amb-tag">' + esc(p) + '</span>'; }).join('') +
               '</span>' +
               '<span class="amb-disc__amt">&minus; ' + money(c.total_discount) + '</span>' +
             '</div>';
      }

      f += '<button type="button" class="amb-co" data-amb="checkout">Checkout &bull; ' + money(c.total_price) + '</button>';
      this.foot.innerHTML = f;
    }
  }

  customElements.define('cart-drawer', AmbCart);
})();
